"use client";

import { useFormStatus } from "react-dom";
import { LoaderIcon } from "@/components/icons";
import { Button } from "./ui/button";

export function SubmitButton({ children, isSuccessful }) {
  const { pending } = useFormStatus();

  return (
    <Button
      aria-disabled={pending || isSuccessful}
      className="relative bg-[#000000] text-[#fafafa] dark:bg-[#ffffff] dark:text-[#000000]"
      disabled={pending || isSuccessful}
      type={pending ? "button" : "submit"}
    >
      {children}

      {(pending || isSuccessful) && (
        <span className="absolute right-4 animate-spin">
          <LoaderIcon />
        </span>
      )}

      <output aria-live="polite" className="sr-only">
        {pending || isSuccessful ? "Loading" : "Submit form"}
      </output>
    </Button>
  );
}
